export const contactsData = {
    email: 'srujanakalyadapu@gmail.com',
    phone: '+17656945240',
    address: '1725 Columbia St., Lafayette, Indiana, United States - 47901 ',

    sheetAPI: 'https://sheetdb.io/api/v1/6d5i71p2ne3mh'
}